import React from "react";
import CommonScrollBar from "../../Common/CommonScrollBar";
import { EmptyState } from "./WarrantyStates";
import "../warranty.css";

// The frame every Phase 2 screen shares: the admin's section and scroll area, the page head, and
// the no-access state for a user without the permission (the OMS refuses the calls anyway).
const WarrantyPage = ({
  title,
  sub,
  actions,
  allowed = true,
  deniedTitle,
  deniedText,
  children,
}) => {
  if (!allowed) {
    return (
      <section className="Main_section">
        <div className="warranty-page">
          <EmptyState title={deniedTitle || "You do not have access to this screen"}>
            <span>{deniedText || "Ask an admin for the matching Warranty permission."}</span>
          </EmptyState>
        </div>
      </section>
    );
  }
  return (
    <section className="Main_section">
      <CommonScrollBar className={"ScrollbarsSidebar"} height={{ height: "calc(100vh - 90px)" }}>
        <div className="warranty-page">
          <div className="warranty-page-head">
            <div>
              <h4>{title}</h4>
              {sub && <p className="warranty-sub">{sub}</p>}
            </div>
            {actions && <div className="warranty-page-actions">{actions}</div>}
          </div>
          {children}
        </div>
      </CommonScrollBar>
    </section>
  );
};

export default WarrantyPage;
